
import {useContext, useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Menu} from 'antd';
import Cookie from 'js-cookie';
import {LeftOutlined} from '@ant-design/icons';
import request from '@/request';
import {SessionStore} from '@/hooks';
import {getProjectType, getQueryVariable} from '@/utils';
import iconIdaas from '../../assets/san-ui/icon-idaas.png';
import {useListen} from './hook';

import './sidebar.less';
import {
    clientItemProps,
    clientSideBar,
    managerItemProps,
    openMenu,
} from './sideBar';

interface titleRenderProps {
    projectInfo: any;
    session: any;
}
const {SubMenu} = Menu;

export default function SideBarClient() {
    const session = useContext(SessionStore);
    const [sideBarSchema, setSideBarSchema] = useState(clientSideBar);
    const [menuOpenAndSelect, setMenuOpenAndSelect] = useState({
        openKeys: [] as string[],
        selectedKeys: [] as string[],
    });
    const [urlParamsStr, setUrlParamsStr] = useState('');

    const [projectId, setProjectId] = useState(() => getQueryVariable('projectId'));

    const [projectInfo, setProjectInfo] = useState(null);

    // 重置密码需要隐藏侧边栏
    const [showBar, setShowBar] = useState(true);

    function setMenOpenKey(schema: Array<clientItemProps | managerItemProps>) {
        const {openKeys, selectedKeys} = openMenu(window.location, schema);
        setMenuOpenAndSelect(() => ({
            openKeys,
            selectedKeys,
        }));
    }


    useListen({
        setUrlParamsStr,
        setMenOpenKey,
        setShowBar,
        setSideBarSchema,
        setProjectId,
    });

    function onOpenChange(arr: Array<string| number>) {
        // const latestOpenKey = [arr[arr.length - 1]].filter(key => key);
        // 存在submenu 则点击展开时 默认选择第一个
        // if (latestOpenKey.length) {
        //     const path = sideBarSchema.find(item => item.key === latestOpenKey[0])
        //         ?.children[0].to as unknown as string;
        //     history.push(path);
        // }
        setMenuOpenAndSelect(state => ({
            ...state,
            openKeys: arr,
        }) as any);
    }


    useEffect(() => {
        (async () => {
            const csrftoken = Cookie.get('bce-user-info');
            if (projectId) {
                const res = await request.post('/api/idaas/project/detail', {
                    projectId,
                }, {
                    headers: {
                        csrftoken,
                    },
                });
                setProjectInfo(res as any);
            } else {
                setProjectInfo(null);
            }
        })();
    }, [projectId]
    );
    const ItemRender = (item: managerItemProps & {urlParamsStr: string}) => {
        return (
            <>
                {item.isPrimitive
                && <a href={`${item.to}${item.urlParamsStr ? `?${item.urlParamsStr}` : ''}`}>{item.label}</a>
                || <Link to={`${item.to}${item.urlParamsStr ? `?${item.urlParamsStr}` : ''}`}>{item.label}</Link>
                }
            </>
        );
    };

    const TitleRender = (item: titleRenderProps) => {
        const projectInfo = item.projectInfo;
        const session = item.session;
        // 有项目信息
        if (projectInfo) {
            return (
                <>
                    <a href="/idaas/#/idaas/project/list">
                        <LeftOutlined className="arrow" />
                    </a>
                    <img src={iconIdaas} />
                    <span>{projectInfo.name}</span>
                </>
            );
        }
        // 公有云 私有云管理端
        if (['publicCloudManager', 'secretManager'].includes(getProjectType())) {
            return (
                <>
                    <img src={iconIdaas} />
                    <span>IDaaS</span></>
            );
        }
        // 客户端
        return <><img src={iconIdaas} /> <span>{session?.project?.name}</span></>;

    };
    return (
        <>
            <div className="sidbar-title">
                <TitleRender projectInfo={projectInfo} session={session} />
            </div>
            {showBar && <Menu
                theme="light"
                mode="inline"
                className="menu-side_wrap"
                openKeys={menuOpenAndSelect.openKeys}
                selectedKeys={menuOpenAndSelect.selectedKeys}
                onOpenChange={onOpenChange}
            >
                {sideBarSchema.map(itemGroup => {
                    if (itemGroup.group) {
                        return (
                            <SubMenu
                                title={itemGroup.title}
                                key={itemGroup.key}
                            >
                                {itemGroup.children.map(itemMenu => {
                                    return (
                                        <Menu.Item
                                            key={itemMenu.key}
                                        >
                                            {
                                                <ItemRender {...itemMenu} urlParamsStr={urlParamsStr} />
                                            }
                                        </Menu.Item>
                                    );
                                })}
                            </SubMenu>
                        );}
                    const manageItem = itemGroup as unknown as managerItemProps;
                    return (
                        <Menu.Item
                            key={manageItem.key}
                        >
                            {
                                <ItemRender {...manageItem} urlParamsStr={urlParamsStr} />
                            }
                        </Menu.Item>
                    );})
                }
            </Menu>
            }
        </>
    );
}


